import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCalendarSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M8.444 4.89h-.177c-1.494 0-2.24 0-2.811.29-.502.255-.91.663-1.165 1.165C4 6.915 4 7.662 4 9.155v1.067M8.444 4.89h7.112m-7.112 0V3.111m0 1.778v1.778m7.112-1.778h.177c1.494 0 2.24 0 2.811.29.502.256.91.664 1.165 1.166.291.57.291 1.317.291 2.81v1.067M15.556 4.89V3.111m0 1.778v1.778M4 10.222v6.4c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h4.178M4 10.222h16m0 0v1.334M17.333 20v-2.666m0 0v-2.667m0 2.667h-2.666m2.666 0H20"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCalendarSearch;
